import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { catchError, filter, map, of, take } from 'rxjs';
import { profilePageTokenizer } from '../store';

export const externalProfileOnlyGuard: CanMatchFn = () => {
  const _profileStore = profilePageTokenizer();
  const _router = inject(Router);

  try {
    return toObservable(_profileStore.$profileData).pipe(
      filter((profileData) => !!profileData?.info),
      map((profileData) => {
        const isInternal = profileData.info?.role?.isInternal;
        return isInternal !== null && !isInternal;
      }),
      take(1),
      catchError(() => of(_router.createUrlTree(['/welcome']))),
    );
  } catch {
    return _router.createUrlTree(['/welcome']);
  }
};
